import { render, staticRenderFns } from "./BlogPostSettingsTabGeneral.vue?vue&type=template&id=1bf9042d&scoped=true&"
import script from "./BlogPostSettingsTabGeneral.vue?vue&type=script&lang=js&"
export * from "./BlogPostSettingsTabGeneral.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostSettingsTabGeneral.vue?vue&type=style&index=0&id=1bf9042d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf9042d",
  null
  
)

export default component.exports